export default [
  {
    path: '/activity-20260130-main',
    component: () => import('./Page.vue'),
    meta: { title: '情人节甜蜜对对碰', id: 19 },
  },
  {
    path: '/activity-20260130-rule',
    component: () => import('./Rule.vue'),
    meta: { title: '情人节甜蜜对对碰-规则', id: 19 },
  },
]
